import {Component, OnInit} from '@angular/core';
import {HelpPageComponent} from '../../help-page.component';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../../environments/environment';

@Component({
    selector: 'app-help-page-activity-thing-monitor',
    templateUrl: './help-page-activity-thing-monitor.component.html',
    styleUrls: ['./help-page-activity-thing-monitor.component.scss', '../../helpPageModule.scss'],
    standalone: false
})
export class HelpPageActivityThingMonitorComponent extends HelpPageComponent implements OnInit
{
    constructor(trans: TranslateService)
    {
        super(trans);
    }

    ngOnInit(): void
    {
    }
    public readonly environment = environment;
}
